import apiClient from "@/clients/apiClient";
import { ApiResponse } from "@/utils/ApiResponse";
import { DashboardResumenInterface } from "../interfaces/dashboardResumen.interface";

export async function getDashboardResumenAction(): Promise<
  ApiResponse<DashboardResumenInterface>
> {
  const { data } = await apiClient.get<DashboardResumenInterface>("reports/dashboard");

  return {
    status: 200,
    data,
    message: "Resumen del dashboard obtenido correctamente",
  };
}